module.exports = __webpack_public_path__ + "img/drag-to-answer-white.cffbe58b.png";